import { HalResource } from '../hal/models/HalResource';
import { EmbeddedCollection } from './EmbeddedCollection';
/**
 * Class representing searches with no results for an Algolia Search Index
 */
export class SearchIndexSearchesWithNoResults extends HalResource {
}
/**
 * @hidden
 */
export class SearchIndexSearchesWithNoResultsCollection extends EmbeddedCollection {
    constructor(data) {
        super('searches-with-no-results', SearchIndexSearchesWithNoResults, data);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VhcmNoSW5kZXhTZWFyY2hlc1dpdGhOb1Jlc3VsdHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL21vZGVsL1NlYXJjaEluZGV4U2VhcmNoZXNXaXRoTm9SZXN1bHRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSwyQkFBMkIsQ0FBQztBQUN4RCxPQUFPLEVBQUUsa0JBQWtCLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUUxRDs7R0FFRztBQUNILE1BQU0sT0FBTyxnQ0FBaUMsU0FBUSxXQUFXO0NBZWhFO0FBRUQ7O0dBRUc7QUFDSCxNQUFNLE9BQU8sMENBQTJDLFNBQVEsa0JBRS9EO0lBQ0MsWUFBWSxJQUFVO1FBQ3BCLEtBQUssQ0FBQywwQkFBMEIsRUFBRSxnQ0FBZ0MsRUFBRSxJQUFJLENBQUMsQ0FBQztJQUM1RSxDQUFDO0NBQ0YifQ==